import { LicenseInfo } from '@mui/x-license';
import ThemedApp from 'ThemedApp';
import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga';
import './GeneralSansFont.css';
import './SwitzerFont.css';
import './index.css';
import './sentry';
import { applyTranslationExtensionFix } from './utils/translationFix';

// Compat for libs that expect a browser `global` (previously an inline index.html script).
// Keeping this in the module graph lets CSP use script-src without 'unsafe-inline'.
// Reflect.set avoids assigning into Node's typed `global` (Global & typeof globalThis).
Reflect.set(globalThis, 'global', globalThis);

LicenseInfo.setLicenseKey(import.meta.env.VITE_APP_MUI_X_LICENSE);

const GOOGLE_ANALYTICS_ID =
    import.meta.env.VITE_APP_ENV === 'prod'
        ? import.meta.env.VITE_APP_GOOGLE_ANALYTICS_ID_PRODUCTION
        : import.meta.env.VITE_APP_GOOGLE_ANALYTICS_ID;

// Initialize Google Analytics
if (GOOGLE_ANALYTICS_ID) {
    ReactGA.initialize(GOOGLE_ANALYTICS_ID);
}

// Apply fix for Chrome translation extension DOM manipulation errors
applyTranslationExtensionFix();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemedApp />
    </React.StrictMode>
);
